import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ContactUsComponent } from '../../../features/contact-us/contact-us.component';
import { ConfigResourceService } from '../../../services/config-resource.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalComponent, ContactUsComponent]
})
export class ContactUsModalComponent implements OnInit, OnDestroy {
  headerText: string = '';
  closeText: string = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly dialogRef: MatDialogRef<ContactUsModalComponent>,
    private readonly configService: ConfigResourceService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.headerText = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Title', 'Contact us');
            this.closeText = this.configService.getProcessedResourceValue<string>('Spa_ContactUsModal_Cancel', 'Close');
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
